export default {
  'User name': '用户名',
  nickname: '昵称',
  grouping: '分组',
  'head portrait': '头像',
  Gender: '性别',
  male: '男',
  female: '女',
  mobile: '手机号',
  'Last login IP': '最后登录IP',
  'Last login': '最后登录',
  email: '电子邮箱',
  birthday: '生日',
  balance: '余额',
  'Adjustment balance': '调整余额',
  integral: '积分',
  'Adjust integral': '调整积分',
  password: '密码',
  'Please leave blank if not modified': '不修改请留空',
  'Personal signature': '个性签名',
  'Login account': '登录账户名'
}
